var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoneTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0663 16.2608C13.4386 14.2193 10.6921 11.3234 9.87035 10.489L6.48612 11.8252L6.41888 11.7895C5.63318 14.0559 5.77618 17.9852 5.77618 17.9852C5.78635 17.9972 5.79582 18.0096 5.80576 18.0217C9.08365 18.0851 13.5261 16.454 14.0663 16.2608Z",
    fill: "#FD6050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7444 14.7458C16.2049 12.6981 16.4468 10.1298 16.5764 9.30329L12.4808 6.68212L9.88071 8.90888V10.4849L9.87036 10.4889C10.6921 11.3234 13.4387 14.2192 14.0663 16.2608C15.6394 15.7522 17.1879 15.0025 17.7444 14.7458Z",
    fill: "#FD8F01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.44896 11.7995L3.23531 10.0935C3.23531 10.0935 -0.000449896 11.9342 0.724021 16.6958C0.724021 16.6958 2.34996 16.6457 3.29596 16.7658C4.24196 16.8859 5.18967 17.2678 5.80626 17.9952C5.80626 17.9952 5.66326 14.0659 6.44896 11.7995Z",
    fill: "#D63B78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.7444 14.7458C20.4764 13.4858 23.8005 11.6974 25.5476 10.1634C25.2724 9.66388 25.051 9.03947 24.9563 8.26082L16.5802 9.3057L16.5764 9.30329C16.4468 10.1298 16.205 12.6981 17.7444 14.7458Z",
    fill: "#FDCB50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.5476 10.1634C23.8005 11.6974 20.4764 13.4858 17.7444 14.7458C17.2225 14.9869 16.6967 15.2195 16.1672 15.4434C16.6961 15.8053 18.7716 17.3241 18.9899 19.0036C20.0062 18.9189 21.1142 18.8944 22.2822 18.9436C23.0909 16.7036 26.7341 12.8395 27.5548 11.9869C27.5429 11.983 26.3278 11.5795 25.5476 10.1634Z",
    fill: "#67CCD1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M29.4118 15.2484C29.4118 15.2484 27.7247 14.377 27.5556 11.9872L27.5549 11.987C26.7341 12.8395 23.091 16.7037 22.2822 18.9436C23.7728 19.0064 25.3611 19.1894 26.9816 19.5211C26.9815 19.5211 28.6827 17.7399 29.4118 15.2484Z",
    fill: "#1A8DC2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.1672 15.4434L16.1129 15.4663C15.4765 15.7336 12.967 16.641 12.396 16.8165C12.3753 17.3157 12.3142 19.7085 12.9717 20.9182C13.4631 20.5503 14.0176 20.2068 14.6221 19.9462C15.6715 19.4938 17.1864 19.1541 18.99 19.0038C18.7717 17.3241 16.6961 15.8052 16.1672 15.4434Z",
    fill: "#91B706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.396 16.8164C10.2366 17.4799 7.90879 17.9783 5.80591 18.0216C6.66308 19.066 6.72008 20.5766 7.45785 21.7128C8.13085 22.7493 9.38073 23.3827 10.6145 23.3126C10.6145 23.3126 11.5159 22.0081 12.9718 20.9181C12.3142 19.7084 12.3753 17.3157 12.396 16.8164Z",
    fill: "#B1D952"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneTab);
export default __webpack_public_path__ + "static/media/zoneTab.033246ff8ac9416beb1bf323a7f42477.svg";
export { ForwardRef as ReactComponent };